import {ref, Ref} from 'vue';
export class EditorUserPlanStoreControllerClass {
	private static _instance: EditorUserPlanStoreControllerClass;

	static instance() {
		return (this._instance = this._instance || new EditorUserPlanStoreControllerClass());
	}

	private _pro: Ref<boolean> = ref(false);
	private _nodesCount: Ref<number> = ref(0);
	private constructor() {}

	isPro(): boolean {
		return this._pro.value;
	}
	nodesCount() {
		return this._nodesCount.value;
	}
	maxNodesCount() {
		return 100;
	}
	nodesCountLimitReached() {
		if (this.isPro()) {
			return false;
		}
		return this.nodesCount() >= this.maxNodesCount();
	}

	// methods
	setPro(state: boolean) {
		this._pro.value = state;
	}
	incrementNodesCount() {
		this._nodesCount.value += 1;
	}
	decrementNodesCount() {
		this._nodesCount.value -= 1;
	}
}

export const EditorUserPlanStoreController = EditorUserPlanStoreControllerClass.instance();
